# TODO: brittany@careerplug.com 10/2 - This code appears to be stale.  The selectors new_assessment_message and new_default_assessment_message do not appear elsewhere.

$(->
  $(document).on 'click', 'a.new_assessment_message', ->
    the_link = $(this)
    the_link.data('post_url', $(this).attr('href'))
    $('#new_default_assessment_message').modal()
    $.post('/manage/users/settings', { 'new_assessment_message_displayed': '1' })
    $('#new_default_assessment_message .modal-footer button.btn-primary').click ->
      $.ajax({
        type: "POST",
        url: the_link.data('post_url'),
        dataType: 'script'
      });
      $('.modal').modal('hide')
    $('a.new_assessment_message').removeClass('new_assessment_message').attr('data-method', 'post').attr('data-remote','true').attr('rel', 'nofollow')
    false
)
